import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { getDatesArray } from '../../Shared/Constant/Constant';
import moment from 'moment';
import { useRouter } from 'next/router';
import { addToCart, cartSelector } from '../../../store/feature/cartSlice';
import { useDispatch, useSelector } from 'react-redux';
import { TYPE_CONSTANT } from '../../../constant/Web_constant';
import { Listing_text } from '../../../constant/Translation/Listing';
import { push_data_layer } from '../../../constant/GTMDatalayer';
import { authSelector } from '../../../store/feature/authSlice';
import { loading_icon } from '../../Shared/Constant/Icons/ComoserIcons';

const SchedulesByCard = ({ listing_details, schedules, styles }) => {
  const [schedules_data, setSchedulesData] = useState([]);
  const [selected_schedule_id, setSelectedScheduleId] = useState(null);
  let dates = getDatesArray();
  const [is_loading, setIsLoading] = useState(false);

  const [selected_schedule, setSelectedSchedule] = useState(
    <i className="ri-nurse-fill"></i>
  );

  useEffect(() => {
    axios
      .post('/api/schedules', {
        id: `${listing_details?.id}`,
        bodyParam: {
          days: 30,
          start_at: moment(dates[0]).format('YYYY-MM-DD'),
        },
      })
      .then((res) => {
        const data = res.data.schedules_per_day;

        //   make all schdeules in singlke leve but need to insert date in each schedule
        const all_schedules = data.map((item) => {
          return item.schedules.map((schedule) => {
            return { ...schedule, day: item.day };
          });
        });
        const flat_schedules = all_schedules.flat();
        setSchedulesData(flat_schedules);
      });
  }, [schedules]);

  const router = useRouter();
  const { cart_details, isFetching } = useSelector(cartSelector);
  const { login } = useSelector(authSelector);

  const dispatch = useDispatch();

  // add to cart
  const add_to_Cart = () => {
    const cartData = {
      cart: {
        listing_id: listing_details?.id,
        quantity: 1,
        uuid: TYPE_CONSTANT.UUID,
        listing_schedule_id: selected_schedule?.id,
        schedule_start_at: `${moment(selected_schedule?.day).format(
          'YYYY-MM-DD'
        )} ${selected_schedule?.start_time}:00`,
        schedule_end_at: `${moment(selected_schedule?.day).format(
          'YYYY-MM-DD'
        )} ${selected_schedule?.end_time}:00`,
        metadata: {
          day: selected_schedule?.day,
          start_at: selected_schedule?.start_time,
          end_at: selected_schedule?.end_time,
        },
      },
    };

    dispatch(addToCart({ data: cartData })).then((res) => {
      if (!res.payload.code) {
        push_data_layer({
          event: 'booknow',
          data: {
            name: listing_details?.title,
            slug: listing_details?.slug,
            price: listing_details?.offer_price.amount,
            stock: listing_details?.stock,
            category: {
              id: listing_details?.categories[0]?.id,
              name: listing_details?.categories[0]?.name,
            },
            image: listing_details?.images,
            url: window.location.href,
          },
        });
        setIsLoading(false);
        router.push('/checkout');
      } else {
        setIsLoading(false);
        console.log(res.payload);
      }
    });
  };

  // clear cart
  const clear_cart = () => {
    setIsLoading(true);
    if (cart_details?.length > 0) {
      axios
        .delete('/api/cart/delete_all_cart')
        .then((res) => {
          add_to_Cart();
        })
        .catch((error) => {
          add_to_Cart();
          console.log(error);
        });
    } else {
      add_to_Cart();
    }
  };

  return (
    <div className=" w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {schedules_data.map((item, index) => {
        const schedule_type = item.schedule_type;
        const total_stocks = item.total_stocks;
        const stocks_left = item.stocks_left;
        const available = item.available;

        const start_time = moment(item.start_time, 'HH:mm').format('hh:mm A');
        const end_time = moment(item.end_time, 'HH:mm').format('hh:mm A');

        return (
          <div
            className={`rounded-lg border bg-white text-gray-900 shadow-sm cursor-pointer transition-all duration-300 hover:shadow-md hover:border-orange-200 ${
              selected_schedule_id === `${item.id}-${item.day}-${index}`
                ? 'border-orange-500 bg-orange-50'
                : available
                ? 'border-gray-200'
                : 'border-gray-200 opacity-50 cursor-not-allowed'
            }`}
            key={`${item.id}-${item.day}-${index}`}
            onClick={() => {
              if (available) {
                setSelectedScheduleId(`${item.id}-${item.day}-${index}`);
                setSelectedSchedule(item);
              }
            }}
          >
            {/* Header */}
            <div className="flex flex-col space-y-1.5 p-6 pb-3">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    {moment(item.day).format('dddd')}
                  </h3>
                  <p className="text-sm text-gray-500">
                    {moment(item.day).format('MMMM DD')}
                  </p>
                </div>

                {selected_schedule_id === `${item.id}-${item.day}-${index}` && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6 text-orange-500"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                    <path d="m9 11 3 3L22 4"></path>
                  </svg>
                )}
              </div>
            </div>

            {/* Content */}
            <div className="p-6 pt-0 space-y-4">
              {/* Time */}
              <div className="flex items-center space-x-2 text-gray-700">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 text-orange-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
                <span className="font-medium">
                  {start_time} - {end_time}
                </span>
              </div>

              {/* Availability */}
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 text-orange-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                  <span className="text-sm font-medium text-green-600">
                    {stocks_left} of {total_stocks} available
                  </span>
                </div>
                {available ? (
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold bg-gray-800 text-white">
                    Available
                  </div>
                ) : (
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold bg-primary text-white">
                    Not Available
                  </div>
                )}
              </div>

              {/* Price + Button */}
              <div
                className="flex items-center justify-between pt-2 border-t border-gray-100"
                id="book_now"
              >
                <span className="text-2xl font-bold text-gray-900">
                  {listing_details.offer_price.formatted}
                </span>
                <button
                  disabled={isFetching}
                  className={`inline-flex items-center justify-center gap-2 h-10 px-4 py-2 rounded-md   text-white text-sm font-medium hover:bg-gray-900 transition-colors ${
                    selected_schedule_id === `${item.id}-${item.day}-${index}`
                      ? 'bg-primary text-white'
                      : 'bg-gray-800 text-white'
                  }`}
                  onClick={() => {
                    if (
                      selected_schedule_id === `${item.id}-${item.day}-${index}`
                    ) {
                      clear_cart();
                    }
                  }}
                >
                  {selected_schedule_id === `${item.id}-${item.day}-${index}`
                    ? 'Book Now'
                    : 'Select'}{' '}
                  {is_loading &&
                    selected_schedule_id ===
                      `${item.id}-${item.day}-${index}` &&
                    loading_icon}
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SchedulesByCard;
